import UploadReportSuccessIcon from "shared/assets/images/upload-report-success.png";
import { GradientBlueCard } from "shared/components/gradient-blue-card/GradientBlueCard";

const UploadReportSucess = () => {
  return (
    <div className="upload-sucess">
      <div className="success-icon">
        <img src={UploadReportSuccessIcon} alt="success-icon" />
      </div>
      <h1>Thank you!</h1>
      <h2>
        Our team has already received your royalty reports and we will contact{" "}
        <span className="block-in-type"></span>
        you soon with the next steps.
      </h2>
      <GradientBlueCard style={{ marginTop: "40px" }}>
        <p style={{ textAlign: "center", lineHeight: 1.5 }}>
          You will receive a confirmation email at your registered{" "}
          <span className="block-in-type"></span> address within the next 24
          hours.
        </p>
      </GradientBlueCard>
    </div>
  );
};

export default UploadReportSucess;
